// Gift a school (sections/sdp-gift-school.liquid), in three steps:
//   1. Find a school: search (city, ZIP, address or name) or Use my location;
//      the schools list beside the map with pins and a card each. Or type the
//      address in.
//   2. Pick your gifts: the school's page (?school=<place id>, the link
//      teachers share) and a grade, then the homepage's Shop sections (the
//      sections after this one in the page template, moved in here). They
//      add to the cart exactly as on the homepage; while a school is picked,
//      anything added from them is marked as a gift for it.
//   3. Confirm and send: the gifts in the cart, a note and who it's from;
//      then checkout.
// Talks to the Wholesale Orders app (data-api):
//   GET /api/gift/catalog                        the note's character limit
//   GET /api/gift/schools?find=1&q= | &lat=&lng= schools near a place, or by name
//   GET /api/gift/school?id=                     a school's address and Google details
//   GET /api/gift/photo?name=&w=                 a school's Google photo (an <img src>)
// Gift lines carry "Gift for", "Grade" (shown) and "_gift_school" (the School
// Gift discount and the app's checkout block look for it); the school, its
// address, the note and who it's from go on the cart as attributes. One
// school per cart. Map: Leaflet + OpenStreetMap, like Find a Retailer.
(function () {
  var root = document.querySelector('[data-sdp-gift]');
  if (!root) return;
  var api = (root.getAttribute('data-api') || '').replace(/\/$/, '');
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var statusEl = $('[data-sdp-gift-status]');
  var listEl = $('[data-sdp-gift-list]');
  var cardEl = $('[data-sdp-gift-card]');
  var overlay = $('[data-sdp-gift-overlay]');
  var manual = $('[data-sdp-gift-manual]');
  var manualError = $('[data-sdp-gift-manual-error]');
  var shop = $('[data-sdp-gift-shop]');
  var gradeBox = $('[data-sdp-gift-grade]');
  function gradeValue() { var c = gradeBox.querySelector('input:checked'); return c ? c.value : 'Whoever needs it'; }

  // A comes before B (the gifts): who it's for (a grade) and who it's from
  // (a postcard, the message and a name, or anonymous). "Continue to gifts"
  // checks it, saves it on the cart and folds A into a summary line; B
  // stays locked until then.
  var aDone = false;
  function aProblem() {
    if (!gradeBox.querySelector('input:checked')) return { msg: 'Pick who it’s for.', el: gradeBox };
    if (state.postcards.length && !postcard()) return { msg: 'Pick a postcard for your message.', el: $('[data-sdp-gift-postcards]') };
    if (note.value.length > state.limit) return { msg: 'Your message is a little long. Please shorten it.', el: note };
    if (!anon.checked && !from.value.trim()) return { msg: 'Add your name, or choose to send it anonymously.', el: from };
    return null;
  }
  function aSummary() {
    var card = postcard();
    return 'For: ' + gradeValue() + ' · From: ' + (anon.checked ? 'Anonymous' : from.value.trim()) + (card ? ' · Card: ' + card.name : '');
  }
  function updateA(scroll) {
    $('[data-sdp-gift-a-form]').hidden = aDone;
    $('[data-sdp-gift-a-summary]').hidden = !aDone;
    if (aDone) {
      var card = postcard();
      $('[data-sdp-gift-tag-for]').textContent = gradeValue();
      $('[data-sdp-gift-tag-from]').textContent = anon.checked ? 'Anonymous' : from.value.trim();
      var msg = note.value.trim();
      var noteEl = $('[data-sdp-gift-tag-note]');
      noteEl.hidden = !msg;
      noteEl.textContent = msg ? '“' + msg + '”' : '';
      var cardEl = $('[data-sdp-gift-tag-card]');
      cardEl.hidden = !(card && card.image);
      if (card && card.image) {
        var im = $('[data-sdp-gift-tag-img]');
        im.src = card.image + (card.image.indexOf('?') > -1 ? '&' : '?') + 'width=360';
        im.alt = card.name || 'Postcard';
      }
    }
    var b = $('[data-sdp-gift-b]');
    b.classList.toggle('is-locked', !aDone);
    $('[data-sdp-gift-b-note]').textContent = aDone
      ? 'Everything you add below goes in your cart as a gift for this school.'
      : 'Finish A first, then choose your gifts.';
    shop.classList.toggle('is-locked', !aDone);
    shop.setAttribute('aria-disabled', aDone ? 'false' : 'true');
    if (aDone && scroll) {
      var top = b.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }
  function editA() {
    aDone = false;
    goto(2);
    updateA(false);
    var card = $('[data-sdp-gift-a-form]');
    window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
  }
  $('[data-sdp-gift-a-done]').addEventListener('click', function (e) {
    var btn = e.currentTarget;
    var errorEl = $('[data-sdp-gift-a-error]');
    var problem = aProblem();
    if (problem) {
      showError(errorEl, problem.msg);
      problem.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (problem.el.focus) problem.el.focus({ preventScroll: true });
      return;
    }
    showError(errorEl, '');
    btn.disabled = true;
    (state.school ? saveAttributes(state.school) : Promise.resolve())
      .then(function () { aDone = true; updateA(true); }, function (err) { showError(errorEl, err.message); })
      .then(function () { btn.disabled = false; });
  });
  $('[data-sdp-gift-a-edit]').addEventListener('click', editA);
  gradeBox.addEventListener('change', function () { showError($('[data-sdp-gift-a-error]'), ''); showGiven(); });

  // Step 2's bar follows you down through the gifts, then slides away once
  // the page's end (the bottom school search, the footer) comes into view.
  (function () {
    var bar = $('.sdp-gift__panel--bar .sdp-gift__bar');
    if (!bar || !('IntersectionObserver' in window)) return;
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      bar.classList.toggle('is-away', seen.size > 0);
    });
    document.querySelectorAll('[data-sdp-gift-bottom], footer, .shopify-section-group-footer-group').forEach(function (el) { io.observe(el); });
  })();

  // What the school has been gifted already, by grade: a 🎁 on those grades,
  // and the gifts listed under the chips when one is picked.
  var given = {};
  var givenFor = '';
  function loadGiven(school) {
    var key = school && school.placeId;
    if (key === givenFor) return;
    givenFor = key || '';
    given = {};
    paintGiven();
    if (!key) return;
    getJSON(api + '/api/gift/given?id=' + encodeURIComponent(key))
      .then(function (data) { if (givenFor === key) { given = (data && data.grades) || {}; paintGiven(); } })
      .catch(function () {});
  }
  function paintGiven() {
    var any = false;
    gradeBox.querySelectorAll('input[type=radio]').forEach(function (r) {
      var has = Boolean(given[r.value] && given[r.value].length);
      any = any || has;
      r.parentNode.classList.toggle('is-given', has);
    });
    $('[data-sdp-gift-given-hint]').hidden = !any;
    showGiven();
  }
  function showGiven() {
    var c = gradeBox.querySelector('input:checked');
    var list = c && given[c.value];
    var box = $('[data-sdp-gift-given]');
    box.hidden = !(list && list.length);
    if (box.hidden) return;
    $('[data-sdp-gift-given-hint]').hidden = true;
    $('[data-sdp-gift-given-title]').textContent = '🎁 Already gifted to ' + (c.value === 'Whoever needs it' ? 'this school' : c.value === 'Whole school' ? 'the whole school' : c.value) + ':';
    var ul = $('[data-sdp-gift-given-list]');
    ul.textContent = '';
    list.forEach(function (g) {
      var li = document.createElement('li');
      li.textContent = (g.quantity > 1 ? g.quantity + ' × ' : '') + g.title;
      var when = document.createElement('span');
      when.textContent = g.month;
      li.appendChild(when);
      ul.appendChild(li);
    });
  }
  var note = $('[data-sdp-gift-note]');
  var count = $('[data-sdp-gift-count]');
  var from = $('[data-sdp-gift-from]');
  var anon = $('[data-sdp-gift-anon]');

  var state = { step: 1, school: null, info: null, limit: 300, found: [], gifts: [], others: 0, postcards: [] };
  var map = null, pins = null, youMarker = null;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function money(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, kind) {
      var n = (cents / 100).toFixed(/no_decimals/.test(kind) ? 0 : 2).split('.');
      n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, /comma_separator/.test(kind) ? '.' : ',');
      return n.join(/comma_separator/.test(kind) ? ',' : '.');
    });
  }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.error || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not update your cart.');
        return j;
      });
    });
  }
  function photo(name, w) { return name ? api + '/api/gift/photo?name=' + encodeURIComponent(name) + '&w=' + w : ''; }
  function oneLine(s) {
    return [s.address1, s.address2, s.city, [s.provinceCode, s.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  }
  function pageUrl(placeId) { return location.pathname + (placeId ? '?school=' + encodeURIComponent(placeId) : ''); }
  function showError(el, message) { el.textContent = message || ''; el.hidden = !message; }
  function schoolKey(s) { return s ? s.placeId || 'manual' : ''; }

  // --- Steps -----------------------------------------------------------------

  function goto(step) {
    if (step >= 2 && !state.school) step = 1;
    if (step === 3 && !state.gifts.length) step = 2;
    state.step = step;
    $$('[data-sdp-gift-step]').forEach(function (el) { el.hidden = Number(el.getAttribute('data-sdp-gift-step')) !== step; });
    shop.hidden = step !== 2;
    $$('.sdp-gift__steps [data-sdp-gift-goto]').forEach(function (b) {
      var n = Number(b.getAttribute('data-sdp-gift-goto'));
      b.disabled = n > 1 && !state.school || n === 3 && !state.gifts.length;
      b.classList.toggle('is-done', n < step);
      if (n === step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    if (step === 1 && map) setTimeout(function () { map.invalidateSize(); }, 0);
    if (step === 3) renderSummary();
    var top = $('.sdp-gift__steps').getBoundingClientRect().top + window.scrollY - 90;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sdp-gift-goto]');
    if (b && !b.disabled) goto(Number(b.getAttribute('data-sdp-gift-goto')));
  });

  // --- Step 1: the map and the list ------------------------------------------

  function drawMap() {
    if (map || !window.L) return;
    map = L.map($('[data-sdp-gift-map]'), { scrollWheelZoom: false, zoomControl: false, zoomSnap: 0.5 });
    L.control.zoom({ position: 'bottomright' }).addTo(map);
    // OpenStreetMap tiles, darkened in CSS (.sdp-rtl__map .leaflet-tile-pane) to match the site.
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    map.fitBounds([[24.5, -125], [49.5, -66.5]]);
    pins = L.layerGroup().addTo(map);
    map.on('click focus', function () { map.scrollWheelZoom.enable(); });
  }
  if (window.L) drawMap(); else window.addEventListener('load', drawMap);

  function thumb(s, cls) {
    return '<span class="' + cls + '">' + (s.photo ? '<img src="' + esc(photo(s.photo, 160)) + '" alt="" loading="lazy" onerror="this.remove()">' : '') +
      '<i aria-hidden="true">' + esc((s.name || '?').charAt(0)) + '</i></span>';
  }

  function search(params, label) {
    overlay.hidden = true;
    cardEl.hidden = true;
    statusEl.textContent = 'Searching…';
    listEl.innerHTML = '';
    getJSON(api + '/api/gift/schools?find=1&' + params)
      .then(function (j) {
        state.found = (j.schools || []).filter(function (s) { return s.lat != null; });
        statusEl.textContent = state.found.length
          ? (j.near ? state.found.length + ' schools near ' : 'Schools matching ') + label
          : 'No schools found. Try another city, ZIP or name, or enter the address yourself.';
        listEl.innerHTML = state.found.map(function (s, i) {
          return '<li data-i="' + i + '"><button type="button">' + thumb(s, 'sdp-rtl__li-photo') +
            '<span class="sdp-rtl__li-text"><span class="sdp-rtl__li-name">' + esc(s.name) + '</span>' +
            '<span class="sdp-rtl__li-addr">' + esc(s.detail) + '</span>' +
            '<span class="sdp-rtl__li-meta">' + esc(s.type) + (s.miles != null ? ' · ' + s.miles + ' mi' : '') + '</span></span></button></li>';
        }).join('');
        drawPins(j.center);
        if (state.found[0]) openCard(0, false);
      })
      .catch(function (err) { statusEl.textContent = err.message; });
  }

  // A city / ZIP / address: in close around it. A name search: around the results.
  function drawPins(center) {
    if (!map) return;
    pins.clearLayers();
    if (youMarker) { youMarker.remove(); youMarker = null; }
    state.found.forEach(function (s, i) {
      L.circleMarker([s.lat, s.lng], { radius: 7, color: '#211b3a', weight: 1.5, fillColor: '#f8e71c', fillOpacity: 1 })
        .addTo(pins).bindTooltip(esc(s.name), { direction: 'top', offset: [0, -8] })
        .on('click', function () { openCard(i, true); });
    });
    if (center) {
      youMarker = L.circleMarker([center.lat, center.lng], { radius: 8, color: '#fff', weight: 3, fillColor: '#4ab4e6', fillOpacity: 1 }).addTo(map);
      map.flyTo([center.lat, center.lng], 14, { duration: 1 });
    } else if (state.found.length) {
      map.flyToBounds(L.latLngBounds(state.found.slice(0, 8).map(function (s) { return [s.lat, s.lng]; })).pad(0.2), { maxZoom: 15, duration: 1 });
    }
  }

  function openCard(i, pan) {
    var s = state.found[i];
    cardEl.innerHTML =
      '<button type="button" class="sdp-rtl__card-x" aria-label="Close" data-sdp-gift-close><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
      (s.photo ? '<div class="sdp-rtl__card-photo"><img src="' + esc(photo(s.photo, 800)) + '" alt="" loading="lazy" onerror="this.parentNode.remove()"><span>Photo: Google</span></div>' : '') +
      '<div class="sdp-rtl__card-body">' +
        '<div class="sdp-rtl__card-badges"><span class="sdp-rtl__dist">' + esc(s.type) + (s.miles != null ? ' · ' + s.miles + ' mi' : '') + '</span></div>' +
        '<h3 class="sdp-rtl__card-name">' + esc(s.name) + '</h3>' +
        '<p class="sdp-rtl__card-addr">' + esc(s.detail) + '</p>' +
        '<div class="sdp-rtl__card-links"><button type="button" class="sdp-whl__card-btn" data-sdp-gift-pick="' + i + '">Gift this school</button></div>' +
      '</div>';
    cardEl.hidden = false;
    $$('[data-sdp-gift-list] li').forEach(function (li) { li.classList.toggle('is-active', Number(li.getAttribute('data-i')) === i); });
    if (map && pan) map.panTo([s.lat, s.lng]);
  }
  cardEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-sdp-gift-close]')) { cardEl.hidden = true; return; }
    var b = e.target.closest('[data-sdp-gift-pick]');
    if (b) openSchool(state.found[Number(b.getAttribute('data-sdp-gift-pick'))].placeId, true);
  });
  listEl.addEventListener('click', function (e) {
    var li = e.target.closest('li[data-i]');
    if (li) openCard(Number(li.getAttribute('data-i')), true);
  });

  $$('[data-sdp-gift-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('[data-sdp-gift-input]');
      var q = input.value.trim();
      if (q.length < 2) { input.focus(); return; }
      $$('[data-sdp-gift-input]').forEach(function (el) { el.value = q; });
      search('q=' + encodeURIComponent(q), q);
    });
  });
  $('[data-sdp-gift-locate]').addEventListener('click', function () {
    if (!navigator.geolocation) { statusEl.textContent = 'Your browser can’t share your location. Try a city or ZIP instead.'; return; }
    overlay.hidden = true;
    statusEl.textContent = 'Finding you…';
    navigator.geolocation.getCurrentPosition(function (p) {
      search('lat=' + p.coords.latitude.toFixed(4) + '&lng=' + p.coords.longitude.toFixed(4), 'you');
    }, function () { statusEl.textContent = 'We couldn’t get your location. Try a city or ZIP instead.'; }, { timeout: 10000 });
  });

  // Typing the address in.
  $('[data-sdp-gift-manual-open]').addEventListener('click', function () {
    manual.hidden = false;
    manual.elements.name.focus();
    manual.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  $('[data-sdp-gift-manual-close]').addEventListener('click', function () { manual.hidden = true; showError(manualError, ''); });
  manual.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = manual.elements;
    var school = {
      placeId: null,
      name: f.name.value.trim(),
      address1: f.address1.value.trim(),
      address2: f.address2.value.trim(),
      city: f.city.value.trim(),
      provinceCode: f.provinceCode.value,
      zip: f.zip.value.trim(),
      countryCode: 'US'
    };
    var missing = !school.name || !school.address1 || !school.city || !school.provinceCode;
    var problem = missing ? 'Please fill in the name and full address.'
      : !/^\d{5}(-\d{4})?$/.test(school.zip) ? 'Please enter a 5-digit ZIP code.'
      : !/^\d/.test(school.address1) ? 'Please enter the street address with its number (e.g. 1234 Main St).'
      : '';
    if (problem) { showError(manualError, problem); return; }
    showError(manualError, '');
    manual.hidden = true;
    showSchool(school, null);
  });

  // --- Step 2: the school's page and the shop --------------------------------

  // The homepage's Shop sections come after this one in the page template:
  // they move into step 2, up to a Section heading (the rest stays below) (their own scripts have already set them up).
  (function moveShop() {
    var section = root.closest('.shopify-section');
    var next = section && section.nextElementSibling;
    while (next) {
      var after = next.nextElementSibling;
      // The rest of the page (Teachers content, Find a school) stays below.
      if (next.querySelector && next.querySelector('[data-sdp-gift-stop], .sdp-apst, .sdp-aplove, [data-sdp-gift-bottom]')) break;
      if (next.classList.contains('shopify-section')) shop.appendChild(next);
      next = after;
    }
  })();

  function openSchool(placeId, push) {
    if (push) history.pushState({ school: placeId }, '', pageUrl(placeId));
    statusEl.textContent = 'Loading the school…';
    return getJSON(api + '/api/gift/school?id=' + encodeURIComponent(placeId))
      .then(function (j) {
        statusEl.textContent = '';
        if (j.incomplete) {
          ['name', 'address1', 'city', 'provinceCode', 'zip'].forEach(function (k) { if (j.school[k]) manual.elements[k].value = j.school[k]; });
          manual.hidden = false;
          showError(manualError, 'We couldn’t find a full street address for ' + j.school.name + '. Please fill it in.');
          goto(1);
          return;
        }
        showSchool(j.school, j.info);
      })
      .catch(function (err) { statusEl.textContent = err.message; goto(1); });
  }

  function showSchool(school, info) {
    info = info || {};
    $('[data-sdp-gift-type]').textContent = info.type || 'School';
    $('[data-sdp-gift-name]').textContent = school.name;
    $('[data-sdp-gift-address]').textContent = oneLine(school);
    function link(key, href, text) {
      var a = $('[data-sdp-gift-' + key + ']');
      a.hidden = !href;
      if (href) { a.href = href; if (text) a.textContent = text; }
    }
    link('phone', info.phone ? 'tel:' + info.phone.replace(/[^\d+]/g, '') : '', info.phone);
    link('website', info.website);
    link('maps', info.mapsUrl);
    // Kept for checkout's thank-you (cart attribute _gift_photo).
    state.photoUrl = info.photo ? photo(info.photo, 800) : '';
    $('[data-sdp-gift-photo]').hidden = !info.photo;
    if (info.photo) {
      $('[data-sdp-gift-photo-img]').src = photo(info.photo, 1200);
      $('[data-sdp-gift-photo-credit]').textContent = 'Photo: Google' + (info.photoCredit ? ' · ' + info.photoCredit : '');
    }
    $('[data-sdp-gift-share]').hidden = !school.placeId;
    $('[data-sdp-gift-share-hint]').hidden = !school.placeId;
    prepareCart(school).then(function (ok) {
      if (!ok) { history.replaceState({}, '', pageUrl(null)); goto(1); return; }
      // A fresh pick of who it's for for each school (who it's from stays).
      if (schoolKey(state.school) !== schoolKey(school) || (state.school && state.school.name !== school.name)) {
        gradeBox.querySelectorAll('input:checked').forEach(function (r) { r.checked = false; });
        aDone = false;
      }
      updateA(false);
      loadGiven(school);
      state.school = school;
      state.info = info;
      goto(2);
    });
  }

  // One school per order: gifts for another school come out first (if they
  // say so). Then the school goes on the cart, ready for gifts.
  function prepareCart(school) {
    return getJSON('/cart.js').then(function (cart) {
      var gifts = cart.items.filter(function (i) { return i.properties && i.properties._gift_school; });
      var prev = null;
      try { prev = JSON.parse((cart.attributes || {})._gift_address || 'null'); } catch (err) { prev = null; }
      var same = prev && schoolKey(prev) === schoolKey(school) && (school.placeId || prev.name === school.name && prev.zip === school.zip);
      var chain = Promise.resolve();
      if (gifts.length && !same) {
        if (!window.confirm('Your cart has a gift for ' + (prev ? prev.name : 'another school') + '. Each order ships to one school. Take it out and gift ' + school.name + ' instead?')) return false;
        var updates = {};
        gifts.forEach(function (i) { updates[i.key] = 0; });
        chain = postJSON('/cart/update.js', { updates: updates });
      }
      return chain.then(function () { return saveAttributes(school); }).then(function () { return true; });
    }).catch(function () { return true; });
  }

  function saveAttributes(school) {
    return postJSON('/cart/update.js', {
      attributes: {
        'Gift school': school.name,
        'Gift address': oneLine(school),
        'Gift note': note.value.trim(),
        'Gift from': anon.checked ? 'Anonymous' : from.value.trim(),
        'Gift postcard': (postcard() || {}).name || '',
        _gift_postcard: (postcard() || {}).id || '',
        _gift_address: JSON.stringify(school),
        _gift_photo: state.photoUrl || '',
        _gift_zip: school.zip
      }
    });
  }

  // Adds from the shop sections in step 2 become gifts: the cart request gets
  // the school and grade. (Adds elsewhere, like the drawer's offers, don't.)
  var giftAddUntil = 0;
  ['click', 'submit'].forEach(function (type) {
    shop.addEventListener(type, function () { if (state.school) giftAddUntil = Date.now() + 4000; }, true);
  });
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var path = url.replace(location.origin, '').split('?')[0];
    if (/^\/cart\/add(\.js)?$/.test(path) && init && init.body && state.school && Date.now() < giftAddUntil) {
      var props = { 'Gift for': state.school.name, Grade: gradeValue(), _gift_school: schoolKey(state.school) };
      if (init.body instanceof FormData) {
        Object.keys(props).forEach(function (k) { init.body.set('properties[' + k + ']', props[k]); });
      } else if (typeof init.body === 'string') {
        try {
          var body = JSON.parse(init.body);
          (body.items || [body]).forEach(function (item) { item.properties = Object.assign({}, item.properties, props); });
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        } catch (err) { /* not JSON: leave it */ }
      }
    }
    var result = nativeFetch(input, init);
    if (/^\/cart\/(add|change|update|clear)(\.js)?$/.test(path)) result.then(function () { setTimeout(refreshGifts, 300); }, function () {});
    return result;
  };

  // The gifts for this school in the cart (for the bar and step 3).
  var refreshing = null;
  function refreshGifts() {
    if (refreshing) return refreshing;
    refreshing = nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var key = schoolKey(state.school);
        state.gifts = state.school ? cart.items.filter(function (i) { return i.properties && i.properties._gift_school === key; }) : [];
        state.others = cart.items.length - cart.items.filter(function (i) { return i.properties && i.properties._gift_school; }).length;
        var n = state.gifts.reduce(function (t, i) { return t + i.quantity; }, 0);
        var total = state.gifts.reduce(function (t, i) { return t + i.final_line_price; }, 0);
        $('[data-sdp-gift-bar-text]').textContent = n ? n + ' gift' + (n === 1 ? '' : 's') + ' for ' + state.school.name + ' · ' + money(total) : 'Add a gift to get started.';
        $('[data-sdp-gift-next]').disabled = !n;
        var step3 = $('.sdp-gift__steps [data-sdp-gift-goto="3"]');
        if (step3) step3.disabled = !n;
        if (state.step === 3) { if (n) renderSummary(); else goto(2); }
      })
      .catch(function () {})
      .then(function () { refreshing = null; });
    return refreshing;
  }
  $('[data-sdp-gift-next]').addEventListener('click', function () { refreshGifts().then(function () { goto(3); }); });

  // "Find a school near me" at the bottom of the page: back to the top, search.
  document.querySelectorAll('[data-sdp-gift-bottom]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      var q = input.value.trim();
      if (q.length < 2) { input.focus(); return; }
      if (state.school) {
        if (new URLSearchParams(location.search).get('school')) history.pushState({}, '', pageUrl(null));
        state.school = null;
        goto(1);
      }
      $$('[data-sdp-gift-input]').forEach(function (el) { el.value = q; });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      search('q=' + encodeURIComponent(q), q);
    });
  });

  $('[data-sdp-gift-change]').addEventListener('click', function () {
    if (new URLSearchParams(location.search).get('school')) history.pushState({}, '', pageUrl(null));
    state.school = null;
    goto(1);
  });
  window.addEventListener('popstate', function () {
    var id = new URLSearchParams(location.search).get('school');
    if (id) openSchool(id, false);
    else { state.school = null; goto(1); }
  });

  $('[data-sdp-gift-share]').addEventListener('click', function (e) {
    var btn = e.currentTarget;
    if (!state.school || !state.school.placeId) return;
    var url = location.origin + pageUrl(state.school.placeId);
    var text = 'Help send a dance party to ' + state.school.name + '!';
    if (navigator.share) { navigator.share({ title: document.title, text: text, url: url }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      btn.textContent = 'Link copied';
      setTimeout(function () { btn.textContent = 'Share this page'; }, 1600);
    }, function () { window.prompt('Copy this link:', url); });
  });

  // --- Step 3: confirm and send ----------------------------------------------

  function renderSummary() {
    var s = state.school;
    $('[data-sdp-gift-sum-school]').textContent = s.name;
    $('[data-sdp-gift-sum-address]').textContent = oneLine(s);
    var grades = [];
    state.gifts.forEach(function (i) { var g = i.properties.Grade; if (g && grades.indexOf(g) < 0) grades.push(g); });
    $('[data-sdp-gift-sum-grade]').textContent = grades.length ? 'For: ' + grades.join(', ') : '';
    $('[data-sdp-gift-lines]').innerHTML = state.gifts.map(function (i) {
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? ' · ' + i.variant_title : '';
      var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
      return '<li>' + (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
        '<span><strong>' + esc(i.product_title) + '</strong>' + esc(variant) + ' &times; ' + i.quantity +
          (i.properties.Grade ? '<br><small>' + esc(i.properties.Grade) + '</small>' : '') + '</span>' +
        '<span>' + (i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s> ' : '') + money(i.final_line_price) + '</span></li>';
    }).join('');
    $('[data-sdp-gift-total]').textContent = money(state.gifts.reduce(function (t, i) { return t + i.final_line_price; }, 0));
    var card = postcard();
    var img = $('[data-sdp-gift-sum-card-img]');
    img.hidden = !card;
    if (card) img.src = card.image + (card.image.indexOf('?') > -1 ? '&' : '?') + 'width=600';
    $('[data-sdp-gift-sum-note]').textContent = note.value.trim() || 'No message.';
    $('[data-sdp-gift-sum-from]').textContent = 'From: ' + (anon.checked ? 'Anonymous' : from.value.trim());
  }
  $('[data-sdp-gift-edit-a]').addEventListener('click', editA);

  // Postcards: the designs from the Gifting page; the note goes on the back.
  var postcardsEl = $('[data-sdp-gift-postcards]');
  function postcard() {
    var c = postcardsEl.querySelector('input:checked');
    return c ? state.postcards.filter(function (p) { return p.id === c.value; })[0] : null;
  }
  function renderPostcards() {
    var keep = (postcard() || {}).id || state.cartPostcard || '';
    $('[data-sdp-gift-postcards-wrap]').hidden = !state.postcards.length;
    $('[data-sdp-gift-note-label]').textContent = state.postcards.length ? 'Your message (printed on the back of the card)' : 'A note to the school';
    postcardsEl.innerHTML = state.postcards.map(function (p) {
      return '<label class="sdp-gift__postcard"><input type="radio" name="sdp-gift-postcard" value="' + esc(p.id) + '"' + (p.id === keep ? ' checked' : '') + '>' +
        '<span class="sdp-gift__postcard-img"><img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=480" alt="" loading="lazy"></span>' +
        '<span class="sdp-gift__postcard-name">' + esc(p.name) + '</span></label>';
    }).join('');
  }

  function updateCount() {
    var left = state.limit - note.value.length;
    count.textContent = left >= 0 ? left + ' characters left' : -left + ' characters too many';
    count.classList.toggle('is-over', left < 0);
  }
  note.addEventListener('input', updateCount);
  // Anonymous clears and grays out the name (put back if they uncheck it).
  var savedFrom = '';
  anon.addEventListener('change', function () {
    if (anon.checked) { savedFrom = from.value; from.value = ''; }
    else if (!from.value) from.value = savedFrom;
    from.disabled = anon.checked;
  });

  function send(checkout, btn) {
    var errorEl = $('[data-sdp-gift-send-error]');
    showError(errorEl, '');
    if (!state.school || !state.gifts.length) { goto(2); return; }
    if (!aDone || aProblem()) { editA(); return; }
    if (checkout && state.others &&
        !window.confirm('Your cart has ' + state.others + ' other item' + (state.others === 1 ? '' : 's') + '. Everything in this order ships to ' + state.school.name + '. Continue to checkout?')) return;
    var label = btn.textContent;
    btn.disabled = true;
    saveAttributes(state.school)
      .then(function () {
        if (checkout) { window.location.href = '/checkout'; return; }
        btn.disabled = false;
        btn.textContent = label;
        goto(2);
        if (window.sdpCart) window.sdpCart.open();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        showError(errorEl, err.message);
      });
  }
  $('[data-sdp-gift-send]').addEventListener('click', function (e) { send(true, e.currentTarget); });
  $('[data-sdp-gift-cart]').addEventListener('click', function (e) { send(false, e.currentTarget); });

  // --- Start -----------------------------------------------------------------

  getJSON(api + '/api/gift/catalog')
    .then(function (cat) {
      state.limit = cat.messageLimit || 300;
      state.postcards = cat.postcards || [];
      renderPostcards();
      note.maxLength = state.limit + 20;
      updateCount();
    })
    .catch(function () { updateCount(); });

  // The note, name and postcard from an earlier gift in the cart.
  getJSON('/cart.js').then(function (cart) {
    var attrs = cart.attributes || {};
    state.cartPostcard = attrs._gift_postcard || '';
    renderPostcards();
    if (attrs['Gift note'] && !note.value) note.value = attrs['Gift note'];
    if (attrs['Gift from'] === 'Anonymous') { anon.checked = true; from.value = ''; from.disabled = true; }
    else if (attrs['Gift from'] && !from.value) from.value = attrs['Gift from'];
    updateCount();
  }).catch(function () {});

  updateA(false);
  goto(1);
  // A school's page (?school=<id>) opens at step 2.
  var shared = new URLSearchParams(location.search).get('school');
  if (shared) {
    history.replaceState({ school: shared }, '', pageUrl(shared));
    openSchool(shared, false);
  }
})();
